import React, { useState } from 'react';

import { useTheme } from '@mui/material/styles';
import { IconButton, AppBar, Box, Toolbar } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';

import Logo from './Logo';
import NotificationButton from './NotificationButton';
import NotificationsDrawer from './NotificationsDrawer';
import ProfileMenu from './ProfileMenu';
import StyledFakeCorner from './StyledComponents/StyledFakeCorner';

const TopBar = ({
    handleDrawerToggle,
    match,
    notificationsQuantity,
    profileValues,
    redirect,
    selectedTheme,
    setTheme,
}) => {
    const [isOpenDrawer, setIsOpenDrawer] = useState(false);

    const theme = useTheme();
    const handleToggleDrawer = (open) => (event) => {
        if (
            event &&
            event.type === 'keydown' &&
            (event.key === 'Tab' || event.key === 'Shift')
        )
            return;
        setIsOpenDrawer(open);
    };
    const isDarkMode = theme.palette.mode === 'dark';

    return (
        <>
            <AppBar
                position="fixed"
                sx={{
                    background: isDarkMode ? '#1B1C1F' : '#002438',
                    boxShadow: isDarkMode ? 'none' : null,
                    color: isDarkMode ? '#b8bfc5' : '#1f3c53',
                    height: '52px',
                    justifyContent: 'center',
                    position: 'sticky',
                    zIndex: 3,
                }}
            >
                <Toolbar>
                    <IconButton
                        onClick={handleDrawerToggle}
                        sx={{ display: { md: 'none' } }}
                    >
                        <Logo />
                    </IconButton>

                    <Box sx={{ display: 'flex', gap: 2, ml: 'auto' }}>
                        <NotificationButton
                            handleToggleDrawer={handleToggleDrawer}
                            quantity={notificationsQuantity}
                        />

                        <ProfileMenu
                            avatarSize={30}
                            match={match}
                            profileValues={profileValues}
                            redirect={redirect}
                            selectedTheme={selectedTheme}
                            setTheme={setTheme}
                        />
                    </Box>
                </Toolbar>
                <StyledFakeCorner
                    sx={{ display: { md: 'block', xs: 'none' }, zIndex: 3 }}
                />
            </AppBar>

            <NotificationsDrawer
                handleToggleDrawer={handleToggleDrawer}
                isOpenDrawer={isOpenDrawer}
                redirect={redirect}
                setIsOpenDrawer={setIsOpenDrawer}
            />
        </>
    );
};

TopBar.propTypes = {
    handleDrawerToggle: PropTypes.func,
    match: PropTypes.object,
    notificationsQuantity: PropTypes.number,
    profileValues: PropTypes.object,
    redirect: PropTypes.func,
    selectedTheme: PropTypes.string,
    setTheme: PropTypes.func,
};

export default TopBar;
